import { Link } from "@tanstack/react-router";
import { Star, MapPin } from "lucide-react";
import {
  type Listing,
  listingHref,
  getCategory,
  getLocation,
} from "@/lib/data";

export function ListingCard({ listing }: { listing: Listing }) {
  const cat = getCategory(listing.category);
  const loc = getLocation(listing.location);
  return (
    <article className="group overflow-hidden rounded-2xl border border-border bg-card shadow-card transition-all hover:-translate-y-0.5 hover:shadow-card-lg">
      <Link {...listingHref(listing)} className="block">
        <div className="aspect-[4/3] overflow-hidden bg-muted">
          <img
            src={listing.image}
            alt={`${listing.name} — ${cat?.name} in ${loc?.name}`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-4">
        <div className="mb-2 flex items-center gap-2 text-xs">
          <span className="rounded-full bg-muted px-2 py-0.5 font-medium text-muted-foreground">
            {cat?.icon} {cat?.name}
          </span>
          <span className="text-muted-foreground">{listing.priceRange}</span>
        </div>
        <Link {...listingHref(listing)}>
          <h3 className="font-display text-lg font-semibold leading-tight transition-colors group-hover:text-primary">
            {listing.name}
          </h3>
        </Link>
        <div className="mt-2 flex items-center gap-3 text-sm text-muted-foreground">
          <span className="flex items-center gap-1 font-medium text-foreground">
            <Star className="h-3.5 w-3.5 fill-accent stroke-accent" />
            {listing.rating}
          </span>
          <span>({listing.reviews})</span>
          <span className="flex items-center gap-1">
            <MapPin className="h-3.5 w-3.5" />
            {loc?.name}
          </span>
        </div>
      </div>
    </article>
  );
}
